import React from 'react';
import styles from './OrdersTable.module.css';
import { OrderStatusBadge } from './OrderStatusBadge';
import { OrderItem } from '../ordersTypes';
import { RowActionsMenu } from '../../../../components/RowActionsMenu';

interface OrdersTableProps {
  items: OrderItem[];
  onCancel?: (id: string) => void;
}

export const OrdersTable: React.FC<OrdersTableProps> = ({ items, onCancel }) => {
  const showActions = !!onCancel;
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Customer</th>
            <th>Sales Rep</th>
            <th>Date</th>
            <th className={styles.thRight}>Items</th>
            <th className={styles.thRight}>Total</th>
            <th className={styles.thRight}>Margin</th>
            <th className={styles.thCenter}>Status</th>
            {showActions && <th></th>}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            // Only allow cancelling orders that haven't been dispatched yet.
            // Once an order is In Transit / Delivered (or already Cancelled),
            // it can no longer be cancelled.
            const cancellable = item.status === 'Pending' || item.status === 'Processing';
            return (
              <tr key={item.id} className={styles.row}>
                <td className={styles.orderId}>{item.orderId}</td>
                <td className={styles.customer}>{item.customer}</td>
                <td>{item.salesRep}</td>
                <td>{item.date}</td>
                <td className={styles.numericCell}>{item.items}</td>
                <td className={styles.numericCell}>${item.total.toLocaleString()}</td>
                <td className={`${styles.numericCell} ${styles.marginValue}`}>{item.margin}%</td>
                <td className={styles.statusCell}>
                  <OrderStatusBadge status={item.status} />
                </td>
                {showActions && (
                  <td>
                    {cancellable && (
                      <RowActionsMenu
                        extra={[
                          {
                            label: 'Cancel Order',
                            destructive: true,
                            onClick: () => onCancel!(item.id),
                          },
                        ]}
                      />
                    )}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
